// e.g
// const items = [
//   {
//     id: 1,
//     title: 'hello'
//   },
//   {
//     id: 2,
//     title: 'bonjour'
//   }
// ];
// normalize(items, 'id')
// ->
// {
//   1: { id: 1, title: 'hello' }
//   2: { id: 2, title: 'bonjour' }
// }
export const normalize = (items, key) => {
  return items.reduce((normalizedItems, item) => {
    return {
      ...normalizedItems,
      [item[key]]: item
    };
  }, {});
};

// this is the reverse of normalize()
// we take an object with ids as keys and return an array
export const denormalize = items => {
  return Object.values(items);
};
